import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsBackward12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSkip5SecondsBackward12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Skip5SecondsBackward12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M8.853 1.025a.5.5 0 0 0-.707 0L6.025 3.146a.5.5 0 0 0 0 .708l2.121 2.12a.5.5 0 0 0 .707-.706L7.586 4H9.5A1.5 1.5 0 0 1 11 5.5v3A1.5 1.5 0 0 1 9.5 10H7a.5.5 0 1 0 0 1h2.5A2.5 2.5 0 0 0 12 8.5v-3A2.5 2.5 0 0 0 9.5 3H7.586l1.267-1.268a.5.5 0 0 0 0-.707M3 6.993C2.996 7.514 2.528 8 1.864 8L.835 7.628a.5.5 0 0 0-.673.74l.338-.37-.338.369h.001l.001.002.004.003.01.008a2 2 0 0 0 .124.1c.08.059.196.135.34.211.29.152.71.308 1.222.308C3.006 9 3.99 8.14 4 7.002c.008-.97-.7-2.007-1.864-2.007-.456 0-.835.077-1.136.178V4h1.955a.5.5 0 1 0 0-1H0v2.996a.5.5 0 0 0 .833.373l.006-.005.047-.035c.047-.032.124-.08.232-.13a2.4 2.4 0 0 1 1.018-.204c.473 0 .869.44.864.998"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Skip5SecondsBackward12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconSkip5SecondsBackward12);
